"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR SaaS-API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 1.3.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.SelfhostedApi = exports.SelfhostedApiFactory = exports.SelfhostedApiFp = exports.SelfhostedApiAxiosParamCreator = exports.OtherApi = exports.OtherApiFactory = exports.OtherApiFp = exports.OtherApiAxiosParamCreator = exports.ContactsApi = exports.ContactsApiFactory = exports.ContactsApiFp = exports.ContactsApiAxiosParamCreator = exports.ClientApi = exports.ClientApiFactory = exports.ClientApiFp = exports.ClientApiAxiosParamCreator = exports.BillingApi = exports.BillingApiFactory = exports.BillingApiFp = exports.BillingApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * BillingApi - axios parameter creator
 * @export
 */
var BillingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get stripe checkout session
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: function (serviceproviderUUID_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1], args_1, true), void 0, function (serviceproviderUUID, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('createCheckoutSession', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/checkout-session"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Creates a new customer in Stripe
         * @param {CreateCustomerRequest} [createCustomerRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: function (createCustomerRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createCustomerRequest_1], args_1, true), void 0, function (createCustomerRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/saas/billing/customers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Creates an invoice for an audit
         * @param {string} serviceproviderUUID
         * @param {CreateInvoiceForAuditRequest} [createInvoiceForAuditRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForAudit: function (serviceproviderUUID_1, createInvoiceForAuditRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1, createInvoiceForAuditRequest_1], args_1, true), void 0, function (serviceproviderUUID, createInvoiceForAuditRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('createInvoiceForAudit', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/invoices/audit"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createInvoiceForAuditRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get stripe portal session
         * @param {string} serviceproviderUUID
         * @param {CreatePortalSessionRequest} [createPortalSessionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession: function (serviceproviderUUID_1, createPortalSessionRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1, createPortalSessionRequest_1], args_1, true), void 0, function (serviceproviderUUID, createPortalSessionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('createPortalSession', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/portal-session"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPortalSessionRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Creates an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {CreateSubscriptionForClientRequest} [createSubscriptionForClientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionForClient: function (serviceproviderUUID_1, createSubscriptionForClientRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1, createSubscriptionForClientRequest_1], args_1, true), void 0, function (serviceproviderUUID, createSubscriptionForClientRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('createSubscriptionForClient', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/subscriptions"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSubscriptionForClientRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Deletes a customer from Stripe
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: function (serviceproviderUUID_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1], args_1, true), void 0, function (serviceproviderUUID, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCustomer', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Deletes an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionForClient: function (serviceproviderUUID_1, subscriptionId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1, subscriptionId_1], args_1, true), void 0, function (serviceproviderUUID, subscriptionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSubscriptionForClient', 'serviceproviderUUID', serviceproviderUUID);
                    // verify required parameter 'subscriptionId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSubscriptionForClient', 'subscriptionId', subscriptionId);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/subscriptions/{subscriptionId}"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)))
                        .replace("{".concat("subscriptionId", "}"), encodeURIComponent(String(subscriptionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets Stripe data for a service provider and optional client
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: function (serviceproviderUUID_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1], args_1, true), void 0, function (serviceproviderUUID, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('getPaymentMethods', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/subscriptions/payment-methods"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets Stripe data for a service provider and optional client
         * @param {string} serviceproviderUUID
         * @param {string} [clientUUID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeData: function (serviceproviderUUID_1, clientUUID_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1, clientUUID_1], args_1, true), void 0, function (serviceproviderUUID, clientUUID, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('getStripeData', 'serviceproviderUUID', serviceproviderUUID);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clientUUID !== undefined) {
                        localVarQueryParameter['clientUUID'] = clientUUID;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Handles external stripe webhooks
         * @param {string} [stripeSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhooks: function (stripeSignature_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([stripeSignature_1], args_1, true), void 0, function (stripeSignature, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/saas/billing/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (stripeSignature != null) {
                        localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Updates an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {string} subscriptionId
         * @param {UpdateSubscriptionForClientRequest} [updateSubscriptionForClientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionForClient: function (serviceproviderUUID_1, subscriptionId_1, updateSubscriptionForClientRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([serviceproviderUUID_1, subscriptionId_1, updateSubscriptionForClientRequest_1], args_1, true), void 0, function (serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceproviderUUID' is not null or undefined
                    (0, common_1.assertParamExists)('updateSubscriptionForClient', 'serviceproviderUUID', serviceproviderUUID);
                    // verify required parameter 'subscriptionId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSubscriptionForClient', 'subscriptionId', subscriptionId);
                    localVarPath = "/saas/billing/customers/{serviceproviderUUID}/subscriptions/{subscriptionId}"
                        .replace("{".concat("serviceproviderUUID", "}"), encodeURIComponent(String(serviceproviderUUID)))
                        .replace("{".concat("subscriptionId", "}"), encodeURIComponent(String(subscriptionId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSubscriptionForClientRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BillingApiAxiosParamCreator = BillingApiAxiosParamCreator;
/**
 * BillingApi - functional programming interface
 * @export
 */
var BillingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BillingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get stripe checkout session
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: function (serviceproviderUUID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCheckoutSession(serviceproviderUUID, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.createCheckoutSession']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Creates a new customer in Stripe
         * @param {CreateCustomerRequest} [createCustomerRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: function (createCustomerRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCustomer(createCustomerRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.createCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Creates an invoice for an audit
         * @param {string} serviceproviderUUID
         * @param {CreateInvoiceForAuditRequest} [createInvoiceForAuditRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForAudit: function (serviceproviderUUID, createInvoiceForAuditRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createInvoiceForAudit(serviceproviderUUID, createInvoiceForAuditRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.createInvoiceForAudit']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get stripe portal session
         * @param {string} serviceproviderUUID
         * @param {CreatePortalSessionRequest} [createPortalSessionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession: function (serviceproviderUUID, createPortalSessionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPortalSession(serviceproviderUUID, createPortalSessionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.createPortalSession']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Creates an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {CreateSubscriptionForClientRequest} [createSubscriptionForClientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionForClient: function (serviceproviderUUID, createSubscriptionForClientRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSubscriptionForClient(serviceproviderUUID, createSubscriptionForClientRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.createSubscriptionForClient']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Deletes a customer from Stripe
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: function (serviceproviderUUID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCustomer(serviceproviderUUID, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.deleteCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Deletes an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionForClient: function (serviceproviderUUID, subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSubscriptionForClient(serviceproviderUUID, subscriptionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.deleteSubscriptionForClient']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Gets Stripe data for a service provider and optional client
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: function (serviceproviderUUID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPaymentMethods(serviceproviderUUID, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.getPaymentMethods']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Gets Stripe data for a service provider and optional client
         * @param {string} serviceproviderUUID
         * @param {string} [clientUUID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeData: function (serviceproviderUUID, clientUUID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStripeData(serviceproviderUUID, clientUUID, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.getStripeData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Handles external stripe webhooks
         * @param {string} [stripeSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhooks: function (stripeSignature, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleStripeWebhooks(stripeSignature, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.handleStripeWebhooks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {string} subscriptionId
         * @param {UpdateSubscriptionForClientRequest} [updateSubscriptionForClientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionForClient: function (serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSubscriptionForClient(serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingApi.updateSubscriptionForClient']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.BillingApiFp = BillingApiFp;
/**
 * BillingApi - factory interface
 * @export
 */
var BillingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BillingApiFp)(configuration);
    return {
        /**
         * Get stripe checkout session
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: function (serviceproviderUUID, options) {
            return localVarFp.createCheckoutSession(serviceproviderUUID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new customer in Stripe
         * @param {CreateCustomerRequest} [createCustomerRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: function (createCustomerRequest, options) {
            return localVarFp.createCustomer(createCustomerRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an invoice for an audit
         * @param {string} serviceproviderUUID
         * @param {CreateInvoiceForAuditRequest} [createInvoiceForAuditRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceForAudit: function (serviceproviderUUID, createInvoiceForAuditRequest, options) {
            return localVarFp.createInvoiceForAudit(serviceproviderUUID, createInvoiceForAuditRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get stripe portal session
         * @param {string} serviceproviderUUID
         * @param {CreatePortalSessionRequest} [createPortalSessionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortalSession: function (serviceproviderUUID, createPortalSessionRequest, options) {
            return localVarFp.createPortalSession(serviceproviderUUID, createPortalSessionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {CreateSubscriptionForClientRequest} [createSubscriptionForClientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionForClient: function (serviceproviderUUID, createSubscriptionForClientRequest, options) {
            return localVarFp.createSubscriptionForClient(serviceproviderUUID, createSubscriptionForClientRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a customer from Stripe
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: function (serviceproviderUUID, options) {
            return localVarFp.deleteCustomer(serviceproviderUUID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionForClient: function (serviceproviderUUID, subscriptionId, options) {
            return localVarFp.deleteSubscriptionForClient(serviceproviderUUID, subscriptionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets Stripe data for a service provider and optional client
         * @param {string} serviceproviderUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: function (serviceproviderUUID, options) {
            return localVarFp.getPaymentMethods(serviceproviderUUID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets Stripe data for a service provider and optional client
         * @param {string} serviceproviderUUID
         * @param {string} [clientUUID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeData: function (serviceproviderUUID, clientUUID, options) {
            return localVarFp.getStripeData(serviceproviderUUID, clientUUID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Handles external stripe webhooks
         * @param {string} [stripeSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhooks: function (stripeSignature, options) {
            return localVarFp.handleStripeWebhooks(stripeSignature, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates an subscription for an monitoring client
         * @param {string} serviceproviderUUID
         * @param {string} subscriptionId
         * @param {UpdateSubscriptionForClientRequest} [updateSubscriptionForClientRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionForClient: function (serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options) {
            return localVarFp.updateSubscriptionForClient(serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BillingApiFactory = BillingApiFactory;
/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
var BillingApi = /** @class */ (function (_super) {
    __extends(BillingApi, _super);
    function BillingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get stripe checkout session
     * @param {string} serviceproviderUUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.createCheckoutSession = function (serviceproviderUUID, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).createCheckoutSession(serviceproviderUUID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new customer in Stripe
     * @param {CreateCustomerRequest} [createCustomerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.createCustomer = function (createCustomerRequest, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).createCustomer(createCustomerRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an invoice for an audit
     * @param {string} serviceproviderUUID
     * @param {CreateInvoiceForAuditRequest} [createInvoiceForAuditRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.createInvoiceForAudit = function (serviceproviderUUID, createInvoiceForAuditRequest, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).createInvoiceForAudit(serviceproviderUUID, createInvoiceForAuditRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get stripe portal session
     * @param {string} serviceproviderUUID
     * @param {CreatePortalSessionRequest} [createPortalSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.createPortalSession = function (serviceproviderUUID, createPortalSessionRequest, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).createPortalSession(serviceproviderUUID, createPortalSessionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an subscription for an monitoring client
     * @param {string} serviceproviderUUID
     * @param {CreateSubscriptionForClientRequest} [createSubscriptionForClientRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.createSubscriptionForClient = function (serviceproviderUUID, createSubscriptionForClientRequest, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).createSubscriptionForClient(serviceproviderUUID, createSubscriptionForClientRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a customer from Stripe
     * @param {string} serviceproviderUUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.deleteCustomer = function (serviceproviderUUID, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).deleteCustomer(serviceproviderUUID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes an subscription for an monitoring client
     * @param {string} serviceproviderUUID
     * @param {string} subscriptionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.deleteSubscriptionForClient = function (serviceproviderUUID, subscriptionId, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).deleteSubscriptionForClient(serviceproviderUUID, subscriptionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets Stripe data for a service provider and optional client
     * @param {string} serviceproviderUUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.getPaymentMethods = function (serviceproviderUUID, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).getPaymentMethods(serviceproviderUUID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets Stripe data for a service provider and optional client
     * @param {string} serviceproviderUUID
     * @param {string} [clientUUID]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.getStripeData = function (serviceproviderUUID, clientUUID, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).getStripeData(serviceproviderUUID, clientUUID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Handles external stripe webhooks
     * @param {string} [stripeSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.handleStripeWebhooks = function (stripeSignature, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).handleStripeWebhooks(stripeSignature, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates an subscription for an monitoring client
     * @param {string} serviceproviderUUID
     * @param {string} subscriptionId
     * @param {UpdateSubscriptionForClientRequest} [updateSubscriptionForClientRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.updateSubscriptionForClient = function (serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).updateSubscriptionForClient(serviceproviderUUID, subscriptionId, updateSubscriptionForClientRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BillingApi;
}(base_1.BaseAPI));
exports.BillingApi = BillingApi;
/**
 * ClientApi - axios parameter creator
 * @export
 */
var ClientApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Gets next billing date for a client
         * @param {string} clientUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextBillingDate: function (clientUUID_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([clientUUID_1], args_1, true), void 0, function (clientUUID, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'clientUUID' is not null or undefined
                    (0, common_1.assertParamExists)('getNextBillingDate', 'clientUUID', clientUUID);
                    localVarPath = "/saas/client/{clientUUID}/next-billing-date"
                        .replace("{".concat("clientUUID", "}"), encodeURIComponent(String(clientUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ClientApiAxiosParamCreator = ClientApiAxiosParamCreator;
/**
 * ClientApi - functional programming interface
 * @export
 */
var ClientApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
    return {
        /**
         * Gets next billing date for a client
         * @param {string} clientUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextBillingDate: function (clientUUID, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNextBillingDate(clientUUID, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClientApi.getNextBillingDate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ClientApiFp = ClientApiFp;
/**
 * ClientApi - factory interface
 * @export
 */
var ClientApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ClientApiFp)(configuration);
    return {
        /**
         * Gets next billing date for a client
         * @param {string} clientUUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextBillingDate: function (clientUUID, options) {
            return localVarFp.getNextBillingDate(clientUUID, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ClientApiFactory = ClientApiFactory;
/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
var ClientApi = /** @class */ (function (_super) {
    __extends(ClientApi, _super);
    function ClientApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets next billing date for a client
     * @param {string} clientUUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    ClientApi.prototype.getNextBillingDate = function (clientUUID, options) {
        var _this = this;
        return (0, exports.ClientApiFp)(this.configuration).getNextBillingDate(clientUUID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ClientApi;
}(base_1.BaseAPI));
exports.ClientApi = ClientApi;
/**
 * ContactsApi - axios parameter creator
 * @export
 */
var ContactsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creates a new contact in Brevo
         * @param {CreateBrevoContactRequest} createBrevoContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrevoContact: function (createBrevoContactRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createBrevoContactRequest_1], args_1, true), void 0, function (createBrevoContactRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'createBrevoContactRequest' is not null or undefined
                    (0, common_1.assertParamExists)('createBrevoContact', 'createBrevoContactRequest', createBrevoContactRequest);
                    localVarPath = "/saas/mailing/contacts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBrevoContactRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Deletes a contact from Brevo
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: function (email_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([email_1], args_1, true), void 0, function (email, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'email' is not null or undefined
                    (0, common_1.assertParamExists)('deleteContact', 'email', email);
                    localVarPath = "/saas/mailing/contacts/{email}"
                        .replace("{".concat("email", "}"), encodeURIComponent(String(email)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Removes a contact from a Brevo list
         * @param {RemoveBrevoContactFromListRequest} removeBrevoContactFromListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBrevoContactFromList: function (removeBrevoContactFromListRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([removeBrevoContactFromListRequest_1], args_1, true), void 0, function (removeBrevoContactFromListRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'removeBrevoContactFromListRequest' is not null or undefined
                    (0, common_1.assertParamExists)('removeBrevoContactFromList', 'removeBrevoContactFromListRequest', removeBrevoContactFromListRequest);
                    localVarPath = "/saas/mailing/contacts/remove-from-list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(removeBrevoContactFromListRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Sends an email using a template
         * @param {SendEmailTemplateRequest} sendEmailTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailTemplate: function (sendEmailTemplateRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sendEmailTemplateRequest_1], args_1, true), void 0, function (sendEmailTemplateRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'sendEmailTemplateRequest' is not null or undefined
                    (0, common_1.assertParamExists)('sendEmailTemplate', 'sendEmailTemplateRequest', sendEmailTemplateRequest);
                    localVarPath = "/saas/mailing/email/template";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendEmailTemplateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ContactsApiAxiosParamCreator = ContactsApiAxiosParamCreator;
/**
 * ContactsApi - functional programming interface
 * @export
 */
var ContactsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContactsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creates a new contact in Brevo
         * @param {CreateBrevoContactRequest} createBrevoContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrevoContact: function (createBrevoContactRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBrevoContact(createBrevoContactRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.createBrevoContact']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Deletes a contact from Brevo
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteContact(email, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.deleteContact']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Removes a contact from a Brevo list
         * @param {RemoveBrevoContactFromListRequest} removeBrevoContactFromListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBrevoContactFromList: function (removeBrevoContactFromListRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeBrevoContactFromList(removeBrevoContactFromListRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.removeBrevoContactFromList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Sends an email using a template
         * @param {SendEmailTemplateRequest} sendEmailTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailTemplate: function (sendEmailTemplateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendEmailTemplate(sendEmailTemplateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContactsApi.sendEmailTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ContactsApiFp = ContactsApiFp;
/**
 * ContactsApi - factory interface
 * @export
 */
var ContactsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContactsApiFp)(configuration);
    return {
        /**
         * Creates a new contact in Brevo
         * @param {CreateBrevoContactRequest} createBrevoContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrevoContact: function (createBrevoContactRequest, options) {
            return localVarFp.createBrevoContact(createBrevoContactRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a contact from Brevo
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: function (email, options) {
            return localVarFp.deleteContact(email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Removes a contact from a Brevo list
         * @param {RemoveBrevoContactFromListRequest} removeBrevoContactFromListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBrevoContactFromList: function (removeBrevoContactFromListRequest, options) {
            return localVarFp.removeBrevoContactFromList(removeBrevoContactFromListRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sends an email using a template
         * @param {SendEmailTemplateRequest} sendEmailTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailTemplate: function (sendEmailTemplateRequest, options) {
            return localVarFp.sendEmailTemplate(sendEmailTemplateRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContactsApiFactory = ContactsApiFactory;
/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
var ContactsApi = /** @class */ (function (_super) {
    __extends(ContactsApi, _super);
    function ContactsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new contact in Brevo
     * @param {CreateBrevoContactRequest} createBrevoContactRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.createBrevoContact = function (createBrevoContactRequest, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).createBrevoContact(createBrevoContactRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a contact from Brevo
     * @param {string} email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.deleteContact = function (email, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).deleteContact(email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Removes a contact from a Brevo list
     * @param {RemoveBrevoContactFromListRequest} removeBrevoContactFromListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.removeBrevoContactFromList = function (removeBrevoContactFromListRequest, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).removeBrevoContactFromList(removeBrevoContactFromListRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sends an email using a template
     * @param {SendEmailTemplateRequest} sendEmailTemplateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    ContactsApi.prototype.sendEmailTemplate = function (sendEmailTemplateRequest, options) {
        var _this = this;
        return (0, exports.ContactsApiFp)(this.configuration).sendEmailTemplate(sendEmailTemplateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContactsApi;
}(base_1.BaseAPI));
exports.ContactsApi = ContactsApi;
/**
 * OtherApi - axios parameter creator
 * @export
 */
var OtherApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get url to collector and updater, used for installer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutables: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/saas/services/executables";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get api health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/saas/services/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Send email with data from website contact form
         * @param {SendContactFormRequest} sendContactFormRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactForm: function (sendContactFormRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sendContactFormRequest_1], args_1, true), void 0, function (sendContactFormRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'sendContactFormRequest' is not null or undefined
                    (0, common_1.assertParamExists)('sendContactForm', 'sendContactFormRequest', sendContactFormRequest);
                    localVarPath = "/saas/services/mailer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendContactFormRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Set new collector version, called via github webhook
         * @param {SetNewCollectorVersionRequest} [setNewCollectorVersionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNewCollectorVersion: function (setNewCollectorVersionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([setNewCollectorVersionRequest_1], args_1, true), void 0, function (setNewCollectorVersionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/saas/services/collector/version/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setNewCollectorVersionRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OtherApiAxiosParamCreator = OtherApiAxiosParamCreator;
/**
 * OtherApi - functional programming interface
 * @export
 */
var OtherApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OtherApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get url to collector and updater, used for installer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutables: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExecutables(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OtherApi.getExecutables']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * get api health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getHealth(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OtherApi.getHealth']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Send email with data from website contact form
         * @param {SendContactFormRequest} sendContactFormRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactForm: function (sendContactFormRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendContactForm(sendContactFormRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OtherApi.sendContactForm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Set new collector version, called via github webhook
         * @param {SetNewCollectorVersionRequest} [setNewCollectorVersionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNewCollectorVersion: function (setNewCollectorVersionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setNewCollectorVersion(setNewCollectorVersionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OtherApi.setNewCollectorVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OtherApiFp = OtherApiFp;
/**
 * OtherApi - factory interface
 * @export
 */
var OtherApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OtherApiFp)(configuration);
    return {
        /**
         * Get url to collector and updater, used for installer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutables: function (options) {
            return localVarFp.getExecutables(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get api health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: function (options) {
            return localVarFp.getHealth(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send email with data from website contact form
         * @param {SendContactFormRequest} sendContactFormRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactForm: function (sendContactFormRequest, options) {
            return localVarFp.sendContactForm(sendContactFormRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Set new collector version, called via github webhook
         * @param {SetNewCollectorVersionRequest} [setNewCollectorVersionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNewCollectorVersion: function (setNewCollectorVersionRequest, options) {
            return localVarFp.setNewCollectorVersion(setNewCollectorVersionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OtherApiFactory = OtherApiFactory;
/**
 * OtherApi - object-oriented interface
 * @export
 * @class OtherApi
 * @extends {BaseAPI}
 */
var OtherApi = /** @class */ (function (_super) {
    __extends(OtherApi, _super);
    function OtherApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get url to collector and updater, used for installer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtherApi
     */
    OtherApi.prototype.getExecutables = function (options) {
        var _this = this;
        return (0, exports.OtherApiFp)(this.configuration).getExecutables(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get api health status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtherApi
     */
    OtherApi.prototype.getHealth = function (options) {
        var _this = this;
        return (0, exports.OtherApiFp)(this.configuration).getHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send email with data from website contact form
     * @param {SendContactFormRequest} sendContactFormRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtherApi
     */
    OtherApi.prototype.sendContactForm = function (sendContactFormRequest, options) {
        var _this = this;
        return (0, exports.OtherApiFp)(this.configuration).sendContactForm(sendContactFormRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Set new collector version, called via github webhook
     * @param {SetNewCollectorVersionRequest} [setNewCollectorVersionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtherApi
     */
    OtherApi.prototype.setNewCollectorVersion = function (setNewCollectorVersionRequest, options) {
        var _this = this;
        return (0, exports.OtherApiFp)(this.configuration).setNewCollectorVersion(setNewCollectorVersionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OtherApi;
}(base_1.BaseAPI));
exports.OtherApi = OtherApi;
/**
 * SelfhostedApi - axios parameter creator
 * @export
 */
var SelfhostedApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * heartbeat for self hosted instances
         * @param {string} selfhostedUUID
         * @param {SendSelfHostedHeartbeatRequest} [sendSelfHostedHeartbeatRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSelfHostedHeartbeat: function (selfhostedUUID_1, sendSelfHostedHeartbeatRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([selfhostedUUID_1, sendSelfHostedHeartbeatRequest_1], args_1, true), void 0, function (selfhostedUUID, sendSelfHostedHeartbeatRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'selfhostedUUID' is not null or undefined
                    (0, common_1.assertParamExists)('sendSelfHostedHeartbeat', 'selfhostedUUID', selfhostedUUID);
                    localVarPath = "/saas/selfhosted/{selfhostedUUID}/heartbeat"
                        .replace("{".concat("selfhostedUUID", "}"), encodeURIComponent(String(selfhostedUUID)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendSelfHostedHeartbeatRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SelfhostedApiAxiosParamCreator = SelfhostedApiAxiosParamCreator;
/**
 * SelfhostedApi - functional programming interface
 * @export
 */
var SelfhostedApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SelfhostedApiAxiosParamCreator)(configuration);
    return {
        /**
         * heartbeat for self hosted instances
         * @param {string} selfhostedUUID
         * @param {SendSelfHostedHeartbeatRequest} [sendSelfHostedHeartbeatRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSelfHostedHeartbeat: function (selfhostedUUID, sendSelfHostedHeartbeatRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendSelfHostedHeartbeat(selfhostedUUID, sendSelfHostedHeartbeatRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SelfhostedApi.sendSelfHostedHeartbeat']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SelfhostedApiFp = SelfhostedApiFp;
/**
 * SelfhostedApi - factory interface
 * @export
 */
var SelfhostedApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SelfhostedApiFp)(configuration);
    return {
        /**
         * heartbeat for self hosted instances
         * @param {string} selfhostedUUID
         * @param {SendSelfHostedHeartbeatRequest} [sendSelfHostedHeartbeatRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSelfHostedHeartbeat: function (selfhostedUUID, sendSelfHostedHeartbeatRequest, options) {
            return localVarFp.sendSelfHostedHeartbeat(selfhostedUUID, sendSelfHostedHeartbeatRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SelfhostedApiFactory = SelfhostedApiFactory;
/**
 * SelfhostedApi - object-oriented interface
 * @export
 * @class SelfhostedApi
 * @extends {BaseAPI}
 */
var SelfhostedApi = /** @class */ (function (_super) {
    __extends(SelfhostedApi, _super);
    function SelfhostedApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * heartbeat for self hosted instances
     * @param {string} selfhostedUUID
     * @param {SendSelfHostedHeartbeatRequest} [sendSelfHostedHeartbeatRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SelfhostedApi
     */
    SelfhostedApi.prototype.sendSelfHostedHeartbeat = function (selfhostedUUID, sendSelfHostedHeartbeatRequest, options) {
        var _this = this;
        return (0, exports.SelfhostedApiFp)(this.configuration).sendSelfHostedHeartbeat(selfhostedUUID, sendSelfHostedHeartbeatRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SelfhostedApi;
}(base_1.BaseAPI));
exports.SelfhostedApi = SelfhostedApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * update email subscription user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionUpdateEmail: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/saas/user/email-subscription/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         * update email subscription user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionUpdateEmail: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubscriptionUpdateEmail(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.getSubscriptionUpdateEmail']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         * update email subscription user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionUpdateEmail: function (options) {
            return localVarFp.getSubscriptionUpdateEmail(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * update email subscription user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getSubscriptionUpdateEmail = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).getSubscriptionUpdateEmail(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
